<template>
    <div class="paginated-content">
        <div class="container">
            <div class="row breadcrumbs justify-content-center mb-2">
                <div class="col-lg-8 col-md-10 col-sm-12">
                    <nav>
                        <ol class="breadcrumb justify-content-between">
                            <li class="breadcrumb-item no-icon"
                                v-for="(step, index) in steps" :key="index"
                                v-bind:class="{ active: stepIsActive(index) }">
                                <a :class="{disabled: step.disabled}" v-on:click="setStepIfAllowed(index)">{{ step.title }}</a>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
        <div v-for="(name, index) in steps" :key="index" v-if="stepIsActive(index)">
            <slot :name="`content_${index}`"/>
        </div>
        <div class="container-fluid">
            <div class="row mt-2 mb-5 navigation-buttons">
                <div class="col text-right">
                    <button class="btn btn-outline-light" v-if="hasPrevStep()" v-on:click="prevStep">< Previous</button>
                </div>
                <div class="col text-left">
                    <button class="btn btn-outline-light" v-if="hasNextStep()" v-on:click="nextStep">Next ></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            steps: Array,
            stepIndex: Number
        },
        data: function () {
            return {

            }
        },
        mounted() {
        },
        methods: {
            stepIsActive: function (index) {
                return this.stepIndex === index;
            },
            nextStep: function () {
                this.$emit('stepIndexChanged', this.stepIndex + 1);
            },
            prevStep: function () {
                this.$emit('stepIndexChanged', this.stepIndex - 1);
            },
            setStepIfAllowed: function (index) {
                if((this.steps[index - 1] && this.steps[index - 1].allowNext) || index < this.stepIndex)
                    this.$emit('stepIndexChanged', index);
            },
            hasPrevStep: function () {
                return this.stepIndex > 0;
            },
            hasNextStep: function () {
                return (this.stepIndex < this.steps.length) && this.steps[this.stepIndex].hasNextButton;
            }
        }
    }
</script>
<style scoped lang="scss">

    @import "../../sass/variables";

    .navigation-buttons {
        .btn {
            color: $red;
            border: none;
            padding: 0.5rem;
            width: 150px;
            font-size: 1.2rem;
        }
    }

    .breadcrumb-item + .breadcrumb-item::before {
        content: ">";
        color: $red;
    }

    .breadcrumb-item.no-icon::before {
        content: "";
    }

    .breadcrumbs {

        .breadcrumb {
            background: transparent;
        }

        .breadcrumb-item {
            font-size: 1.2rem;
            font-weight: 300;
        }

        .breadcrumb-item.active {
            font-weight: 500;
        }

        .breadcrumb-item.active::before {
            font-weight: 300;
        }

        a {
            color: $red;
        }

        a.disabled {
            color: dimgrey;
        }
    }
</style>
